import { fetchPageAssets } from '../../ducks/hostedAssets.duck';
export const TOS_ASSET_NAME = 'terms-of-service';
export const PRIVACY_POLICY_ASSET_NAME = 'privacy-policy';
export const PRIVACY_POLICY_ARABIC_ASSET_NAME = 'privacy-policy-arabic';

export const loadData = (params, search) => dispatch => {
  const arabicLanguage = typeof window !== 'undefined' && localStorage.getItem('language') === 'Arabic';

  const pageAsset = {
    termsOfService: `content/pages/${arabicLanguage ? PRIVACY_POLICY_ARABIC_ASSET_NAME : PRIVACY_POLICY_ASSET_NAME}.json`,
    privacyPolicy: `content/pages/${arabicLanguage ? PRIVACY_POLICY_ARABIC_ASSET_NAME : PRIVACY_POLICY_ASSET_NAME}.json`,
  };
  return dispatch(fetchPageAssets(pageAsset, true));
};
